<template>
  <div>
    <div class="ui two item pointing secondary menu" ref="tabs">
      <a class="active item" data-tab="request">
        <i class="share icon"></i>
        {{ $t("request") }}
      </a>
      <a class="item" data-tab="response">
        <i class="reply icon"></i>
        {{ $t("response") }}
      </a>
    </div>
    <div class="ui bottom attached tab segment" data-tab="request">
      <code-editor
        :title="$t('request body')"
        v-model="request"
        type="javascript"
        :show_format="true"
        :header_buttons="header_buttons"
      />
    </div>
    <div class="ui bottom attached tab segment" data-tab="response">
      <code-editor
        :title="$t('response')"
        v-model="response"
        type="javascript"
        :show_format="true"
        ref="response_code"
      />
    </div>
  </div>
</template>

<script>
import CodeEditor from "@/components/code_editor/Index";
import { error_toast, api_host } from "@/utils";

export default {
  name: "Testing",
  components: { CodeEditor },
  props: {
    endpoint_in: Object,
  },
  computed: {},
  data() {
    return {
      request: "",
      response: "",
      header_buttons: [
        {
          icon: "blue lightning",
          click: this.test,
          tooltip: this.$t("execute"),
        },
      ],
    };
  },
  methods: {
    test() {
      try {
        let vm = this;
        let bdy = vm.request ? JSON.parse(vm.request) : {};
        // let setup = JSON.parse(vm.endpoint_in.setup);
        // local_api(vm, "post", "/api_manager/do-test-endpoint", {
        vm.$http
          .post(`${api_host}/apis${vm.endpoint_in.setup.general.url}`, bdy, {
            timeout: 600000,
          })
          .then((rspnse) => {
            vm.response = JSON.stringify(rspnse);
            setTimeout(() => {
              vm.$refs.response_code.format_code();
            }, 500);
          })
          .catch((err) => {
            console.error(err);
            error_toast(err);
          });
      } catch (err) {
        console.error(err);
        error_toast(err);
      }
    },
  },
  mounted() {
    window
      .jQuery(this.$refs.tabs)
      .find(".item")
      .tab();
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
